export default {
  data(){
    return  {
      refreshEvent: 'def-refresh',//默认刷新事件 可重写
    }
  },
  created() {
    
  },
  mounted(){
    this.$nextTick(() => {
      //监听组件刷新事件
      this.$bus.$off(this.refreshEvent).$on(this.refreshEvent, this.refresh)
     
    })
  },
  destroyed(){
    //销毁时取消监听
    this.$bus.$off(this.refreshEvent)
  },
  methods: {
    /**
     * 复制对象属性
     * @param {*} source 源对象
     * @param {*} target 目标对象
     */
    copyProperties(source, target){
      let keys = Object.keys(target)
      return new Promise((resolve) => {
        keys.forEach((key, index) => {
          target[key] = source[key]
          if(index == keys.length - 1){
            resolve()
          }
        })
      })
    },
    /**
     * 重置表单数据
     * @param {*} formRef 表单组件名称 默认 form
     */
    async resetFormData(formRef = 'form'){
      this.$refs[formRef] && this.$refs[formRef].resetFields()
      return
    },
    /**
     * 重置data
     * @param {*} excludes 排除key
     * @returns 
     */
    async resetData(excludes = []){
      //默认排除rules
      excludes.push('rules')
      return await this.resetObj(this._data, excludes)
    },
    //页面刷新 可重写
    refresh(params){
      this.refreshTable(params)
    },
    //刷新表格 可重写
    refreshTable(){
      
      console.log("刷新表格")
      
    },
    
    //递归重置对象
    async resetObj(obj, excludes = []){
      if(!obj) return
      Object.keys(obj).forEach((key) => {
        if(excludes.indexOf(key) > -1) return
        let val = obj[key]
        if(val instanceof Array) {
          obj[key] = []
          return
        }
        if(val instanceof Object) {
          this.resetObj(obj[key], excludes)
          return
        }
        obj[key] = undefined
      })
      return true
    }
  }
}